import request from '@/utils/request'

// pc端固定客户端授权id
const clientId = process.env.VUE_APP_CLIENT_ID
const tenantId = process.env.VUE_APP_TENANT_ID
const grantType = process.env.VUE_APP_LOGIN_GRANT_TYPE

/**
 * @param  roomId roomId
 * @param  gType gType
 * @param  cId cId
 * @param  tId tId
 * @returns
 */
export function login(roomId, gType, cId, tId) {
    const data = {
        roomId,
        grantType: gType || grantType,
        clientId: cId || clientId,
        tenantId: tId || tenantId,
    }
    return request({
        url: '/auth/login',
        headers: {
            isToken: false,
            repeatSubmit: false,
            isEncrypt: true
        },
        method: 'post',
        data: data
    })
}

/**
 * 注销
 */
export function logout() {
    return request({
        url: '/auth/logout',
        method: 'post',
    })
}
